module.exports = {"OFFER_DETAILS":"Détails de l'offre","OFFER_STATS":"Statistiques de l'offre","CLAIMS_STATS":"Offres réclamées","TRX_STATS":"Transactions<br><small>#conversionRate#% d'offres réclamées</small>","SALES_STATS":"Ventes totales","AVERAGE_PER_CLIENT_STATS":"Dépense moyenne par client","CASHBACK_STATS":"Total des remises","CASHBACK_STATS_TOOLTIP":"Total des montants des remises incluant les taxes","MARKETING_FEES_STATS":"Total des frais marketing (avant taxes)","MARKETING_FEES_STATS_TOOLTIP":"Total des frais marketing avant taxes"}


//////////////////
// WEBPACK FOOTER
// ./src/app/locale/fr/deal.json
// module id = 429
// module chunks = 8